/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode } from '@angular/core';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

import { Amplify } from 'aws-amplify';
import { captureEntryAppMode } from './app/views/public/auth/new-app-mode';

import amplifyconfig from './amplifyconfiguration.json';
import { registerLicense, enableVersionBasedPersistence } from '@syncfusion/ej2-base';
import { Grid } from '@syncfusion/ej2-angular-grids';

// Registering Syncfusion license key
registerLicense('NAsnBzUROFJ8Wm51S0RpV1hNf1ZfXGFUfVJmR2BTeld6cVxNYlxTQnZYQF9hSntUd0FlW3Zae3dR');

// Grids with [enablePersistence]="true" cache their full column list (including
// type/format) in localStorage keyed only by the grid id, with no schema check.
// When a grid's column definitions change in code, stale localStorage state from
// before the change gets merged back in on load and can desync field <-> format,
// e.g. throwing "value.getDate is not a function" for a date column. Enabling
// version-based persistence keys the stored state by each grid's
// Version-based persistence keys the stored state by each grid's
// `ej2StatePersistenceVersion`, so bumping that version whenever a grid's columns
// change invalidates old cached state instead of corrupting the new layout.
enableVersionBasedPersistence(true);

Amplify.configure(amplifyconfig);

if (environment.production) {
  enableProdMode();
  console.log = function() {};
  console.warn = function() {};
  console.error = function() {};
  console.time = function() {};
  console.timeEnd = function() {};
}

const originalGetPersistData = Grid.prototype.getPersistData;

Grid.prototype.getPersistData = function () {
  const data = JSON.parse(originalGetPersistData.call(this));

  // ❌ remove filters globally
  delete data.filterSettings;

  return JSON.stringify(data);
};


// Must run before the router's first navigation - it rewrites the URL and drops
// a pre-hash `?mode=new`. See new-app-mode.ts.
captureEntryAppMode();

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
